import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoney = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22.0004 7H9.99963H9.99958H3C1.89543 7 1 7.89543 1 9V15.0004V15.0004V16.9996C1 16.9996 1 16.9996 1 16.9996V23C1 24.1046 1.89543 25 3 25H9.99227C9.99716 25 10.0021 25 10.0069 25H21.9931H22.0078H29C30.1046 25 31 24.1046 31 23V17.0069V16.9923V15.0078V14.9931V9C31 7.89543 30.1046 7 29 7H22.0004H22.0004ZM10.3757 23H21.6243L29 16.5463V15.4538L21.6243 9H10.3758L3 15.4538V16.5462L10.3757 23ZM3 19.2038V23H7.33855L3 19.2038ZM3 12.7963L7.33858 9H3V12.7963ZM29 19.2038V23H24.6615L29 19.2038ZM29 9H24.6614L29 12.7962V9ZM13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16ZM16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11Z"
	})
});
export default SvgMoney;
